/***************************************/
/*              SERVICES               */
/***************************************/

const AUTH = "/auth"
const BENEFICIARIES = "/beneficiaires"
const CAPTCHA = "/captcha"
const EBS = "/api/espace-beneficiaire-service/service"
const SIDOMI = "/api/sidomi/service"
const FEATURES = "/fonctionnalites"
const INTERVENANTS = "/intervenants"
const MILLESIME_TRADE = "/echange-millesime"
const PASSWORD = "/password"
const PREORDER_SESSIONS = "/sessions-precommande"
const REPORT = "/rapports"
const SEARCH = "/search"
const SERVICE_API = "/api/service"
const SERVIDOM = "/servidom"
const STATISTICS = "/statistiques"
const TUTORS = "/tuteurs"
const URSSAF = "/urssaf"
const UTIL = "/util"
const CERTIFICAT_AIDANT = SERVICE_API + "/certificat-aidant"
const INSCRIPTION_CLIENT = "/clients/inscription"
const SIRET = "/siret"

/**
 * Endpoint pour obtenir un intervenant pour le contrôle de pré-inscription (obtenu par nanCode/nanKey et date de naissance ou SIRET)
 */
export const GET_INTERVENANT_FOR_PRE_REGISTRATION_CONTROL_ENDPOINT =
    SERVICE_API + INTERVENANTS + "/controle-pre-inscription"

/**
 * Endpoint pour créer un contact client lors de l'inscription financeur.
 */
export const CREATE_CONTACT_CLIENT_ENDPOINT = SERVICE_API + INSCRIPTION_CLIENT + "/creation-contact"

/**
 * Endpoint pour créer un prospect lors de l'inscription financeur.
 */
export const CREATE_PROSPECT_ENDPOINT = SERVICE_API + INSCRIPTION_CLIENT + "/creation-prospect"

/**
 * Endpoint pour obtenir le profil d'un intervenant
 */
export const INTERVENANT_PROFILE_ENDPOINT = SERVICE_API + INTERVENANTS + "/profil"

/**
 * Endpoint pour obtenir un fichier de personnalisation.
 */
export const GET_CUSTOMIZATION_FILE_ENDPOINT = "/api/service/filer/personnalisation"

/**
 * Endpoint pour télécharger un fichier depuis le filer Arborescence
 */
export const FILER_DOWNLOAD_ARBORESCENCE_ENDPOINT = "/api/service/filer/telecharge-arborescence"

/**
 * Endpoint pour télécharger un fichier depuis le filer Demande Gestion
 */
export const FILER_DOWNLOAD_DEMANDE_GESTION_ENDPOINT = "/api/service/filer/telecharge-demande-gestion"

/**
 * Endpoint pour télécharger un fichier depuis le filer Demande Remise
 */
export const FILER_DOWNLOAD_REMISE_ENDPOINT = "/api/service/filer/telecharge-remise"

/**
 * Endpoint pour télécharger un fichier depuis le filer
 */
export const FILER_DOWNLOAD_DEPOT_COMMANDE_ENDPOINT = "/api/service/filer/telecharge-depot-commandes"

/**
 * Endpoint pour télécharger un fichier depuis le filer Pièce Dépôt Commande
 */
export const FILER_DOWNLOAD_PIECE_DEPOT_COMMANDE_ENDPOINT = "/api/service/filer/telecharge-piece-depot-commandes"

/**
 * Endpoint pour connecter un utilisateur.
 */
export const CONNECT_USER_ENDPOINT = "/api/service/auth/login"

/**
 * Endpoint pour valider un code MFA.
 */
export const VALIDATE_MFA_ENDPOINT = "/api/mfa/validate"

/**
 * Endpoint pour demander un nouveau code MFA.
 */
export const REQUEST_NEW_MFA_CODE_ENDPOINT = "/api/mfa/request"

/**
 * Endpoints pour AuthAPI
 */
export const AUTH_ENDPOINTS = {
    bypassLogin: SERVICE_API + AUTH + "/bypass-login",
    logout: `${SERVICE_API}${AUTH}/logout`,
    recoverLoginBeneficiaryArea: SERVICE_API + AUTH + "/recover/login",
    recoverLogin: SERVICE_API + AUTH + "/recover/login",
    recoverLoginPassword: SERVICE_API + AUTH + "/recover",
    getParamBypass: SERVICE_API + AUTH + "/bypass/param",
    validateAccount: SERVICE_API + AUTH + "/validate-account",
    validateFid: SERVICE_API + AUTH + "/validate-fid",
}

/**
 * Endpoints pour CaptchaAPI
 */
export const CAPTCHA_ENDPOINTS = {
    render: `${SERVICE_API}${CAPTCHA}/render`,
    validate: `${SERVICE_API}${CAPTCHA}/validate`,
}

/**
 * Endpoints appel de Sidomi vers servidom
 */
export const SERVIDOM_ENDPOINTS = {
    getBeneficiaryCounters: (numeroContrat, idBeneficiaire) =>
        `${EBS}/contrat/${numeroContrat}/beneficiaire/${idBeneficiaire}/dispositif/compteur`,
    getSapClientByContrat: idBeneficiaire => `${SIDOMI}/beneficiaire/sap-clients/${idBeneficiaire}`,
    getCommandes: (numeroContrat, idBeneficiaire) =>
        `${EBS}/beneficiaire/${idBeneficiaire}/commandes/${numeroContrat}/ebu`,
    getContratFaq: numeroContrat => `${EBS}/faq/contrat/${numeroContrat}`,
    getFactures: (numeroContrat, idBeneficiaire) => `${EBS}/beneficiaire/${idBeneficiaire}/factures/${numeroContrat}`,
    getFacturesByBeneficiaireAndClientId: (idBeneficiaire, idClient) =>
        `${EBS}/beneficiaire/${idBeneficiaire}/client/${idClient}/factures`,
    getFacturePdf: (numeroBeneficiaireSap, numeroFacture) =>
        SERVICE_API +
        "/filer" +
        SERVIDOM +
        `/beneficiaire/${numeroBeneficiaireSap}/factures/${numeroFacture}/telecharge-pdf`,
    getMandatBeneficiaireActif: idBeneficiaire => `${EBS}/beneficiaire/${idBeneficiaire}/mandat`,
    getScelliusData: idBeneficiaire => SERVICE_API + `/paiement/${idBeneficiaire}/initialiser-formulaire-mandat`,
    getStatutAiciBeneficiaire: idBeneficiaire => SERVICE_API + `/aici/statut/${idBeneficiaire}`,
    contratIsEligibleAIci: (contractId, idBeneficiaire) =>
        `${EBS}/contrat/${contractId}/beneficiaire/${idBeneficiaire}/activate-aici`,
}

/**
 * Endpoint pour récupérer les informations de l'utilisateur connecté
 */
export const GET_USER_INFO_ENDPOINT = "/api/service/auth/connected"

/**
 * Endpoint pour récupérer les informations de profil de l'utilisateur connecté
 */
export const GET_USER_PROFILE_INFO_ENDPOINT = "/api/service/compte-utilisateur/profil/informations"

/**
 * Endpoint pour rechercher un bénéficiaire.
 */
export const SEARCH_BENEFICIARY_ENDPOINT = SERVICE_API + SEARCH + "/beneficiary"
/**
 * Endpoint pour rechercher un bénéficiaire lié à un identifiant de contrat.
 */
export const SEARCH_MANAGEMENT_REQUEST_BENEFICIARY_ENDPOINT = SERVICE_API + SEARCH + "/demande-gestion-beneficiaires"
/**
 * Endpoint pour rechercher une ville.
 */
export const SEARCH_TOWN_ENDPOINT = SERVICE_API + SEARCH + "/town"
/**
 * Endpoint pour la recherche d'une commune.
 */
export const SEARCH_COMMUNE_ENDPOINT = SERVICE_API + SEARCH + "/commune"

/**
 * Endpoint pour valider un SIRET.
 */
export const SIRET_VALIDATION_ENDPOINT = "/api/service/siret-validation/validate"

/**
 * Endpoints utilisés lors de l'inscription à l'espace financeur
 */
export const REGISTRATION_ENDPOINTS = {
    verifierSiretFinanceur: siret => `${SERVICE_API}${INSCRIPTION_CLIENT}/verification-existant/${siret}`,
    rechercheEntreprisesParSiret: `${SERVICE_API}${SIRET}/search-siret`,
    rechercheEntreprisesParRaisonSociale: `${SERVICE_API}${SIRET}/search-raison-sociale`,
}

/**
 * Endpoints mot de passe
 */
export const PASSWORD_ENDPOINTS = {
    changeActualPassword: SERVICE_API + PASSWORD + "/modification",
    changePassword: SERVICE_API + PASSWORD + "/update",
}
/**
 * Endpoint pour les informations de profil de l'utilisateur connecté
 */
export const PROFILE_INFO_ENDPOINT = "/api/service/profil"

/**
 * Endpoint pour obtenir les règles de calcul des factures.
 */
export const GET_RULES_INVOICE_CALCULATIONS = "/api/service/calculs-facturation/regles"

/**
 * Endpoint pour obtenir la TVA pour le calcul des factures.
 */
export const GET_TVA_INVOICE_CALCULATIONS = "/api/service/calculs-facturation/tva"

/**
 * Endpoint pour enregistrer les commandes en ligne.
 */
export const SAVE_ONLINE_ORDER = "/api/service/commande-en-ligne"

/**
 * Endpoint pour modifier une commande en ligne existante.
 */
export const MODIFY_ONLINE_ORDER = "/api/service/commande-en-ligne/modification"

/**
 * Endpoint pour enregistrer l'étape de livraison d'une commande en ligne.
 */
export const SAVE_LIVRAISON_ONLINE_ORDER = "/api/service/commande-en-ligne/livraison"

/**
 * Endpoint pour calculer les coûts des commandes en ligne.
 */
export const CALCULATE_ONLINE_ORDER_COSTS = "/api/service/commande-en-ligne/couts"

/**
 * Endpoint pour obtenir les résultats des commandes en ligne.
 */
export const GET_ONLINE_ORDER_RESULTS = "/api/service/commande-en-ligne/resultats"

/**
 * Endpoint pour obtenir la commande en ligne en cours.
 */
export const GET_ONLINE_ORDER_IN_PROGRESS = "/api/service/commande-en-ligne/en-cours"

/**
 * Enpoint pour savoir si on a au moins une commande en cours
 */
export const GET_ONLINE_ORDER_IN_PROGRESS_EXISTS = "/api/service/commande-en-ligne/en-cours/existante"

/**
 * Endpoint pour finaliser une commande en ligne (validation du paiement par virement).
 */
export const FINALISATION_ONLINE_ORDER = "/api/service/commande-en-ligne/finalisation"

/**
 * Endpoints Scellius.
 */
export const SCELLIUS_ENDPOINTS = {
    beneficiaryAccountTradeOrder: SERVICE_API + "/scellius/espace-beneficiaire/initialiser-paiement-echange-millesime",
    beneficiaryIntervenantAccountPayment:
        SERVICE_API + "/scellius/espace-beneficiaire/initialiser-paiement-compte-intervenant",
    beneficiaryPreOrderData: SERVICE_API + "/scellius/espace-beneficiaire/initialiser-paiement-precommande",
    onlineOrderData: SERVICE_API + "/scellius/espace-financeur/initialiser-paiement",
    tradeOrderData: SERVICE_API + "/scellius/espace-echange/initialiserPaiement",
    transactionState: SERVICE_API + "/scellius/etat-paiement",
}

export const PAYNUM_DEMANDE_ACTIONS = {
    VOIR_DETAILS: "/details",
    EDITER: "/editer",
}

export const PAYNUM_ENDPOINTS = {
    getDemandesCesuPaynum: numeroContrat => SERVICE_API + "/paynum/contrat/" + numeroContrat + "/demandes",
    creerDemandeCesuPaynum: numeroContrat => SERVICE_API + "/paynum/contrat/" + numeroContrat + "/creer-demande",
    editerDemandeCesuPaynum: (numeroContrat, idDemande, action) =>
        SERVICE_API + "/paynum/contrat/" + numeroContrat + "/demande/" + idDemande + action,
    supprimerDemandeCesuPaynum: (numeroContrat, idDemande) =>
        SERVICE_API + "/paynum/contrat/" + numeroContrat + "/demande/" + idDemande + "/supprimer",
    modifierChoixSupportDemandeCesuPaynum: (numeroContrat, idDemande) =>
        SERVICE_API + "/paynum/contrat/" + numeroContrat + "/demande/" + idDemande + "/modifier-choix-support",
}

/**
 * Endpoint pour obtenir les informations de duplication.
 */
export const GET_DUPLICATION_INFORMATION_ENDPOINT = SERVICE_API + "/commande-en-ligne/information-duplication"

/**
 * Endpoint pour générer et télécharger un export Excel
 */
export const EXCEL_DOWNLOAD_ENDPOINT = SERVICE_API + "/excel/export"

/**
 * Endpoints pour obtenir l'arborescence des rapports.
 */
export const GET_REPORTS_TREE_ENDPOINT_START = SERVICE_API + REPORT + "/"
export const GET_REPORTS_TREE_ENDPOINT_END = "/arbre"

/**
 * Endpoints pour enregistrer un nouveau fichier dans l'arborescence des rapports.
 */
export const SAVE_NEW_REPORTS_FILE_ENDPOINT_START = SERVICE_API + REPORT + "/"
export const SAVE_NEW_REPORTS_FILE_ENDPOINT_END = "/ajout/fichier"

/**
 * Endpoints pour enregistrer un nouveau dossier dans l'arborescence des rapports.
 */
export const SAVE_NEW_REPORTS_FOLDER_ENDPOINT_START = SERVICE_API + REPORT + "/"
export const SAVE_NEW_REPORTS_FOLDER_ENDPOINT_END = "/ajout/dossier"

/**
 * Endpoints pour supprimer un fichier de l'arborescence des rapports.
 */
export const DELETE_REPORTS_FILE_ENDPOINT_START = SERVICE_API + REPORT + "/"
export const DELETE_REPORTS_FILE_ENDPOINT_END = "/retrait/fichier"

/**
 * Endpoints pour supprimer un dossier de l'arborescence des rapports.
 */
export const DELETE_REPORTS_FOLDER_ENDPOINT_START = SERVICE_API + REPORT + "/"
export const DELETE_REPORTS_FOLDER_ENDPOINT_END = "/retrait/dossier"

/**
 * Endpoints environnement
 */
export const ENVIRONMENT_ENDPOINTS = {
    beneficiaryUrl: SERVICE_API + "/environment/espace-beneficiaire/url",
    beneficiaryRegistrationUrl: SERVICE_API + "/environment/espace-beneficiaire/url-inscription",
    beneficiaryLoginUrl: SERVICE_API + "/environment/espace-beneficiaire/login/url",
}

/**
 * Endpoint pour créer ou mettre à jour une session de précommande
 * @type {[type]}
 */
export const PREORDER_SESSION_CREATE_UPDATE_ENDPOINT = SERVICE_API + PREORDER_SESSIONS + "/creation-modification"

/**
 * Endpoints pour la remise de chéquiers
 */
export const INTERVENANTS_ENDPOINTS = {
    changeActualPassword: SERVICE_API + INTERVENANTS + "/profil/infos-connexion",
    createSimpleHandOver: SERVICE_API + INTERVENANTS + "/remises/simple",
    createBarCodeHandOver: SERVICE_API + INTERVENANTS + "/remises/codebarre",
    createFileHandOver: SERVICE_API + INTERVENANTS + "/remises/fichier",
    generateBillTransfer: reglementId => SERVICE_API + INTERVENANTS + "/remboursements/titres/" + reglementId + "/pdf",
    generatePdf: remiseId => SERVICE_API + INTERVENANTS + "/remises/" + remiseId + "/pdf",
    profileMainInformations: SERVICE_API + INTERVENANTS + "/profil/infos-principales",
    profileRefundInformations: SERVICE_API + INTERVENANTS + "/profil/infos-remboursement",
    retrieveAccountPayments: SERVICE_API + INTERVENANTS + "/remboursements/compte",
    retrieveCheckTransfers: SERVICE_API + INTERVENANTS + "/remboursements/titres",
    retrieveFileRefunds: SERVICE_API + INTERVENANTS + "/remises/fichier/suivi",
    retrieveRefund: refundId => SERVICE_API + INTERVENANTS + "/remises/" + refundId,
    retrieveRefunds: SERVICE_API + INTERVENANTS + "/remises",
    retrieveTransferDetails: transferId => SERVICE_API + INTERVENANTS + "/remboursements/reglements/" + transferId,
    validateCheckbook: SERVICE_API + INTERVENANTS + "/titres/validation/simple",
    validateCheckbookListWithBarcode: SERVICE_API + INTERVENANTS + "/titres/validation/codebarres",
    validateCheckbookWithBarcode: SERVICE_API + INTERVENANTS + "/titres/validation/codebarre",
}

/**
 * Endpoints features
 */
export const FEATURES_ENDPOINTS = {
    getBeneficiaryEnabledFeatures: SERVICE_API + FEATURES + BENEFICIARIES,
}

/**
 * Endpoints statistiques financeur
 */
const FINANCEUR_STATISTICS = SERVICE_API + STATISTICS + "/financeur"
export const STATISTICS_FINANCEUR_ENDPOINTS = {
    generalData: () => FINANCEUR_STATISTICS + "/donnees-generales",
    beneficiaryStats: beneficiaryId => FINANCEUR_STATISTICS + BENEFICIARIES + "/" + beneficiaryId + "/statistiques",
    beneficiaryAccountsHistory: beneficiaryId =>
        FINANCEUR_STATISTICS + BENEFICIARIES + "/" + beneficiaryId + "/historiques/comptes",
    beneficiaryTitlesHistory: beneficiaryId =>
        FINANCEUR_STATISTICS + BENEFICIARIES + "/" + beneficiaryId + "/historiques/titres",
    intervenantAccountsHistory: intervenantId =>
        FINANCEUR_STATISTICS + INTERVENANTS + "/" + intervenantId + "/historiques/comptes",
    intervenantAccountsStats: intervenantId =>
        FINANCEUR_STATISTICS + INTERVENANTS + "/" + intervenantId + "/statistiques/comptes",
    intervenantTitlesHistory: intervenantId =>
        FINANCEUR_STATISTICS + INTERVENANTS + "/" + intervenantId + "/historiques/titres",
    intervenantTitlesStats: intervenantId =>
        FINANCEUR_STATISTICS + INTERVENANTS + "/" + intervenantId + "/statistiques/titres",
}

/**
 * Endpoints échange millésime
 */
export const MILLESIME_TRADE_ENDPOINTS = {
    calculateTradingFees: SERVICE_API + MILLESIME_TRADE + "/calculer-frais",
    checkSecretCodeTitle: SERVICE_API + MILLESIME_TRADE + "/titres/case-a-gratter",
    checkValidTitles: SERVICE_API + MILLESIME_TRADE + "/titres/validation",
    getMillesimeInTrade: SERVICE_API + MILLESIME_TRADE + "/millesime-en-periode",
    validateOrder: SERVICE_API + MILLESIME_TRADE + "/valider-commande",
}

/**
 * Endpoints utilitaires
 */
export const UTIL_ENDPOINTS = {
    calculateFacialValues: SERVICE_API + UTIL + "/calculer-valeur-faciale",
}

/**
 * Endpoint pour les certificats aidant
 */
export const CERTIFICAT_AIDANT_ENDPOINTS = {
    createCertificatAidant: CERTIFICAT_AIDANT + "/create",
    demandeEnCoursCertificatAidant: CERTIFICAT_AIDANT + "/en-cours",
    retrieveCertificatAidant: CERTIFICAT_AIDANT + "/retrieve",
    downloadCertificatAidant: numeroCertificat => `${CERTIFICAT_AIDANT}/download/${numeroCertificat}`,
}

/**
 * Endpoints commande bénéficiaire
 */
export const BENEFICIARY_ENDPOINTS = {
    calculateReloadingFees: SERVICE_API + BENEFICIARIES + "/paiements/comptes/calculer-frais",
    calculPaymentComplementFees: SERVICE_API + BENEFICIARIES + "/paiements/comptes/calculer-frais-complement",
    cancelOrder: sessionId => SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/annuler",
    changeActualPassword: SERVICE_API + BENEFICIARIES + "/profil/infos-connexion",
    createOrUpdatePreOrder: sessionId => SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/precommande",
    checkControlInformations: sessionId =>
        SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/verification-infos-complementaires",
    checkControlInformationsForRegistration: (contractId, sessionId) =>
        SERVICE_API +
        BENEFICIARIES +
        "/inscription/" +
        contractId +
        (sessionId ? "/sessions/" + sessionId : "") +
        "/infos",
    checkIfAlreadyRegistered: (contractId, sessionId) =>
        SERVICE_API +
        BENEFICIARIES +
        "/inscription/" +
        contractId +
        (sessionId ? "/sessions/" + sessionId : "") +
        "/deja-inscrit",
    checkSecretCode: SERVICE_API + BENEFICIARIES + "/transformation/titres/case-a-gratter",
    convertAccountToChecks: SERVICE_API + BENEFICIARIES + "/transformation/compte-en-titres",
    convertChecksToAccount: SERVICE_API + BENEFICIARIES + "/transformation/titres-en-compte",
    downloadAccountStatementPDF: cesuAccountNumber =>
        SERVICE_API + BENEFICIARIES + "/consultation/comptes/" + cesuAccountNumber + "/releve/pdf",
    downloadPaymentRequestPDF: paymentRequestId =>
        SERVICE_API + BENEFICIARIES + "/paiements/comptes/" + paymentRequestId + "/pdf",
    downloadBeneficiaryCheckPaymentSlipPDF: refundNumber =>
        SERVICE_API + BENEFICIARIES + "/paiements/titres/" + refundNumber + "/pdf",
    getBeneficiaryPart: sessionId =>
        SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/calculer-part-beneficiaire",
    getClientBeneficiaireInfos: numeroContrat =>
        SERVICE_API + BENEFICIARIES + "/contrats/" + numeroContrat + "/client-beneficiaire",
    getContracts: SERVICE_API + BENEFICIARIES + "/contrats",
    getOrderCeiling: sessionId => SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/calculer-max-precommande",
    getOrderOverviewFromSession: sessionId =>
        SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/commande-details",
    getOrderInformationsFromSession: sessionId =>
        SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/commande-informations",
    getParamsFid: numeroContrat => SERVICE_API + BENEFICIARIES + "/inscription/" + numeroContrat + "/fid",
    getRegistrationParameters: contractId => SERVICE_API + BENEFICIARIES + "/inscription/" + contractId,
    getSessionsOfContract: contractId => SERVICE_API + BENEFICIARIES + "/inscription/" + contractId + "/sessions",
    getSessionComplementaryInfoForBeneficiary: sessionId =>
        SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/infos-complementaires",
    getSessionDeliveryInformations: sessionId =>
        SERVICE_API + BENEFICIARIES + "/sessions/" + sessionId + "/infos-livraison",
    hasAccountsOrCheckbooksConvertibles: SERVICE_API + BENEFICIARIES + "/transformation",
    makeBeneficiaryAccountPaymentRequest: SERVICE_API + BENEFICIARIES + "/paiements/comptes/demande",
    makeBeneficiaryCheckPaymentRequest: SERVICE_API + BENEFICIARIES + "/paiements/titres/remise",
    makeBeneficiaryRegistration: (contractId, sessionId) =>
        SERVICE_API + BENEFICIARIES + "/inscription/" + contractId + (sessionId ? "/sessions/" + sessionId : ""),
    updateMainInformationsProfile: SERVICE_API + BENEFICIARIES + "/profil/infos-principales",
    updateBeneficiaryCguAcceptationDate: SERVICE_API + BENEFICIARIES + "/accept-cgu",
    retrieveActiveCesuAccounts: SERVICE_API + BENEFICIARIES + "/comptes",
    retrieveMaxCreditCardSlice: SERVICE_API + BENEFICIARIES + "/paiements/comptes/montant-max",
    retrieveOpenedSessions: SERVICE_API + BENEFICIARIES + "/sessions",
    retrieveOrderClients: SERVICE_API + BENEFICIARIES + "/commandes/financeurs",
    retrieveOrderDetails: orderId => SERVICE_API + BENEFICIARIES + "/commandes/" + orderId,
    retrieveOrderHistory: SERVICE_API + BENEFICIARIES + "/commandes",
    retrieveBeneficiaryPaymentHistory: SERVICE_API + BENEFICIARIES + "/paiements",
    retrievePaidIntervenants: SERVICE_API + BENEFICIARIES + "/paiements/intervenants",
    retrieveProductTypeChoice: SERVICE_API + BENEFICIARIES + "/choix-type-produit",
    retrieveBeneficiarySearchedIntervenants: SERVICE_API + BENEFICIARIES + "/paiements/recherche/intervenants",
    retrieveUsableCesuChecks: SERVICE_API + BENEFICIARIES + "/titres",
    retrieveBeneficiaryAccountsForStatement: SERVICE_API + BENEFICIARIES + "/consultation/comptes",
    retrieveBeneficiaryAccountStatement: accountNumber =>
        SERVICE_API + BENEFICIARIES + "/consultation/comptes/" + accountNumber + "/releve",
    retrieveBeneficiaryCheckbookStatement: productId =>
        SERVICE_API + BENEFICIARIES + "/consultation/titres/" + productId + "/releve",
    retrieveBeneficiaryCheckbooksForStatement: SERVICE_API + BENEFICIARIES + "/consultation/titres",
    retrieveBeneficiaryConvertiblesAccounts: SERVICE_API + BENEFICIARIES + "/transformation/produits-comptes",
    retrieveBeneficiaryConvertiblesCheckbooks: SERVICE_API + BENEFICIARIES + "/transformation/produits-titres",
    retrieveBeneficiaryCheckbooksForIntervenantPayment:
        SERVICE_API + BENEFICIARIES + "/paiements/titres/produits-titres",
    retrieveBeneficiaryChecksForIntervenantPayment: productId =>
        SERVICE_API + BENEFICIARIES + "/paiements/titres/produits-titres/" + productId + "/titres",
    retrieveBeneficiaryConvertiblesChecks: productId =>
        SERVICE_API + BENEFICIARIES + "/transformation/produits-titres/" + productId + "/titres",
    updateProductTypeChoice: SERVICE_API + BENEFICIARIES + "/choix-type-produit",
    retrieveTaxDocument: SERVICE_API + BENEFICIARIES + "/attestation-fiscale/liste",
    downloadTaxDocumentPDF: taxDocumentId =>
        SERVICE_API + BENEFICIARIES + "/attestation-fiscale/" + taxDocumentId + "/pdf",
}

/**
 * Endpoints échange millésime bénéficiaire
 */
export const BENEFICIARY_MILLESIME_TRADE_ENDPOINTS = {
    calculateTradingFees: SERVICE_API + BENEFICIARIES + "/echange-millesime/calculer-frais",
    generateTradeBill: transactionReference =>
        SERVICE_API + BENEFICIARIES + "/echange-millesime/factures/" + transactionReference + "/pdf",
    retrieveBeneficiaryAccountsForMillesimeTrade: SERVICE_API + BENEFICIARIES + "/echange-millesime/comptes",
    retrieveTradeParametersByCesuAccountNumber: cesuAccountNumber =>
        SERVICE_API + BENEFICIARIES + "/echange-millesime/comptes/" + cesuAccountNumber + "/parametres-echange",
    validateOrder: SERVICE_API + BENEFICIARIES + "/echange-millesime/valider-commande",
}

/**
 * Endpoints session de précommande
 */
export const PREORDER_SESSION_ENDPOINTS = {
    closePreOrderSession: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/cloturer",
    createPreOrderSessionOrder: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/commander",
    getAllPreOrderSessions: contractId => ENTITY_API + CONTRACT + "/" + contractId + PREORDER_SESSIONS,
    getPreOrderSessionDetails: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId,
    getPreOrderSessionInformation: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/information",
    getPreOrderSessionLines: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/lignes",
    getPreOrderSessionOrders: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/commandes",
    getPreOrderSessionMatricule: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/matricule",
    getPreOrderSessionStatistics: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/statistiques",
    updatePreOrderSessionLines: sessionId => SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/maj/lignes",
    validationControleFile: contractNumber => SERVICE_API + PREORDER_SESSIONS + "/" + contractNumber + "/control-file",
    validatePreOrderAllWaitingLines: sessionId =>
        SERVICE_API + PREORDER_SESSIONS + "/" + sessionId + "/valider/lignes-en-attentes",
}

/**
 * Endpoints URSSAF CESU
 */
export const URSSAF_CESU_ENDPOINTS = {
    checkEmployeeAccount: SERVICE_API + URSSAF + "/cesu/verifier-compte-salarie",
    checkEmployerAccount: cesuNumber => SERVICE_API + URSSAF + "/cesu/verifier-compte-employeur/" + cesuNumber,
    downloadDeclarationReceipt: declarationId => SERVICE_API + URSSAF + "/cesu/teledeclaration/" + declarationId,
    getInfoFromLastDeclaration: SERVICE_API + URSSAF + "/cesu/infos-identification",
    getLastCesuCodeAndMandateState: SERVICE_API + URSSAF + "/cesu/infos-profil-declaration",
    makeDeclaration: cesuNumber => SERVICE_API + URSSAF + "/cesu/teledeclaration/" + cesuNumber,
    retrieveDeclarationsHistory: SERVICE_API + URSSAF + "/cesu/teledeclarations",
    retrieveDeclaredEmployeeCesuNumbers: SERVICE_API + URSSAF + "/cesu/teledeclarations/salaries",
    retrieveDeclaredEmployerCesuNumbers: SERVICE_API + URSSAF + "/cesu/teledeclarations/employeurs",
    updateMandateState: SERVICE_API + URSSAF + "/cesu/mandat",
}

/**
 * Endpoints URSSAF PAJE
 */
export const URSSAF_PAJE_ENDPOINTS = {
    checkAndAddChildren: pajeNumber => SERVICE_API + URSSAF + "/paje/enfants/" + pajeNumber,
    checkChildById: (pajeNumber, childId) => SERVICE_API + URSSAF + "/paje/enfants/" + pajeNumber + "/" + childId,
    checkEmployeeAccount: SERVICE_API + URSSAF + "/paje/verifier-compte-salarie",
    checkEmployerAccount: pajeNumber => SERVICE_API + URSSAF + "/paje/verifier-compte-employeur/" + pajeNumber,
    downloadDeclarationReceipt: declarationId => SERVICE_API + URSSAF + "/paje/teledeclaration/" + declarationId,
    getInfoFromLastDeclaration: SERVICE_API + URSSAF + "/paje/infos-identification",
    getLastDeclaration: pajeNumber => SERVICE_API + URSSAF + "/paje/teledeclaration/" + pajeNumber + "/derniere",
    getLastPajeCodeAndMandateState: SERVICE_API + URSSAF + "/paje/infos-profil-declaration",
    makeAmaDeclaration: pajeNumber => SERVICE_API + URSSAF + "/paje/teledeclaration/ama/" + pajeNumber,
    makeAmaPreDeclaration: pajeNumber => SERVICE_API + URSSAF + "/paje/pre-teledeclaration/ama/" + pajeNumber,
    makeAssociation: SERVICE_API + URSSAF + "/paje/association",
    makeGedDeclaration: pajeNumber => SERVICE_API + URSSAF + "/paje/teledeclaration/ged/" + pajeNumber,
    makeGedPreDeclaration: pajeNumber => SERVICE_API + URSSAF + "/paje/pre-teledeclaration/ged/" + pajeNumber,
    retrieveChildren: pajeNumber => SERVICE_API + URSSAF + "/paje/enfants/" + pajeNumber,
    retrieveDeclarationsHistory: SERVICE_API + URSSAF + "/paje/teledeclarations",
    retrieveDeclaredEmployeePajeNumbers: SERVICE_API + URSSAF + "/paje/teledeclarations/salaries",
    retrieveDeclaredEmployerPajeNumbers: SERVICE_API + URSSAF + "/paje/teledeclarations/employeurs",
    updateMandateState: SERVICE_API + URSSAF + "/paje/mandat",
    retrievePajeDeclarationHistory: SERVICE_API + URSSAF + "/paje/teledeclarations",
}

/***************************************/
/*              ENTITE                 */
/***************************************/

const ENTITY_API = "/api/entity"

const BANKS = "/banques"
const BANK_ACCOUNTS = "/compte-bancaires"
const BILLS = "/factures"
const CONTRACT = "/contrat-client"
const CLIENT = "/clients"
const KINDS_WAY_ADDRESS = "/genres-voie-adresse"
const LEGAL_FORMS = "/formes-juridique"
const MANAGEMENT_REQUEST = "/demande-gestion"
const ORDERS = "/commandes"
const ORDER_LINES = "/lignes-commandes"
const ORDER_REASONS = "/ref-motif-commande"
const ORDER_TYPES = "/ref-type-commande"
const PARAMETERS = "/parametres"
const TITLE_STATE_TYPES = "/ref-etat-titre-cesu"
const TYPES_WAY_ADDRESS = "/types-voie-adresse"
const WEB_ACCESS = "/acces-web"

/**
 * ENDPOINTS CLIENT
 */
export const CLIENT_ENDPOINTS = {
    retrieveLinkedWebAccesses: contractId => ENTITY_API + CONTRACT + "/" + contractId + WEB_ACCESS,
    getClientInformations: clientId => ENTITY_API + CLIENT + "/" + clientId,
    getParamEspaceDomiserveByClientId: clientId => ENTITY_API + CLIENT + "/" + clientId + "/param-espace-domiserve",
}

/**
 * ENDPOINTS PARAMETRES
 */
export const PARAMETERS_ENDPOINTS = {
    DOMISERVE: {
        getRib: ENTITY_API + PARAMETERS + "/domiserve/rib",
        getUrlEbs: ENTITY_API + PARAMETERS + "/domiserve/url/ebs",
        getUrlEbc: ENTITY_API + PARAMETERS + "/domiserve/url/ebc",
    },
}

/**
 * Endpoint pour obtenir le style personnalisé.
 */
export const GET_STYLE_ENDPOINT = "/api/entity/personnalisation/style"

/**
 * Endpoint pour obtenir les textes personnalisés.
 */
export const GET_TEXTS_ENDPOINT = "/api/entity/personnalisation/texte"

/**
 * Endpoint pour les bénéficiaires d'un contrat.
 */
export const GET_BENEFICIARIES_ENDPOINT_START = "/api/entity/contrat-client/"
export const GET_BENEFICIARIES_ENDPOINT_END = "/beneficiaires"
export const GET_BENEFICIARIES_SEARCH_ENDPOINT_END = "/recherche"
export const PATCH_BENEFICIARIES_ACTIVATIONS_ENDPOINT_END = "/activation"

/**
 * Endpoints pour la création, la modification et la suppression d'un bénéficiaire depuis l'espace client (financeur).
 */
export const BENEFICIAIRE_CLIENT_ENDPOINTS = {
    createBeneficiaire: (idClient, numeroContrat) =>
        SERVICE_API + BENEFICIARIES + "/client/" + idClient + "/contrats/" + numeroContrat,
    updateBeneficiaire: (idClient, numeroContrat, beneficiaireId) =>
        SERVICE_API + BENEFICIARIES + "/client/" + idClient + "/contrats/" + numeroContrat + "/" + beneficiaireId,
    deleteBeneficiaire: (idClient, numeroContrat, beneficiaireId) =>
        SERVICE_API + BENEFICIARIES + "/client/" + idClient + "/contrats/" + numeroContrat + "/" + beneficiaireId,
}

/**
 * Endpoint pour les intervenants d'un contrat.
 */
export const GET_INTERVENANTS_ENDPOINT_START = "/api/entity/contrat-client/"
export const GET_INTERVENANTS_ENDPOINT_END = "/intervenants"
export const GET_INTERVENANTS_SEARCH_ENDPOINT_END = "/recherche"

/**
 * Endpoint pour les ressources de genres de voie d'adresse
 */
export const GET_ALL_KINDS_WAY_ADDRESS_ENDPOINT = ENTITY_API + KINDS_WAY_ADDRESS

/**
 * Endpoint pour les ressources de formes juridiques
 */
export const GET_ALL_LEGAL_FORMS_ENDPOINT = ENTITY_API + LEGAL_FORMS

/**
 * Endpoint pour les ressources de types de voie d'adresse
 */
export const GET_ALL_TYPES_WAY_ADDRESS_ENDPOINT = ENTITY_API + TYPES_WAY_ADDRESS

/**
 * Endpoint pour obtenir les produits d'un contrat.
 */
export const GET_PRODUCTS_ENDPOINT_START = "/api/entity/contrat-client/"
export const GET_PRODUCTS_ENDPOINT_END = "/produits"

/**
 * Endpoint pour créer un dépôt de commande
 */
export const CREATE_ORDER_DEPOSIT_ENPDOINT = "/api/entity/depot-commande"

/**
 * Endpoint pour récupérer les dépôts de commande
 */
export const RETRIEVE_ORDER_DEPOSITS_ENDPOINT_START = "/api/entity/contrat-client/"
export const RETRIEVE_ORDER_DEPOSITS_ENDPOINT_END = "/depot-commandes"

/**
 * Endpoint pour vérifier une opération marketing.
 */
export const VERIFY_MARKETING_OPERATION_ENDPOINT = "/api/entity/operation-marketing/verification"

/**
 * Endpoint pour récupérer tous les types de prestation
 */
export const RETRIEVE_ALL_SERVICE_TYPES_ENDPOINT = "/api/entity/prestation-limitation"

/**
 * Endpoint pour récupérer la liste de référence des types de prestations "moteur de recherche"
 * (utilisé pour la recherche directe d'intervenant : critères de prestation).
 */
export const RETRIEVE_MOTEUR_TYPE_SERVICES_ENDPOINT = ENTITY_API + "/ref-moteur-type-service"

/**
 * Endpoint pour rechercher des intervenants directement (par type de prestation et localisation).
 */
export const SEARCH_DIRECT_INTERVENANTS_ENDPOINT = SERVICE_API + INTERVENANTS + "/recherche"

/**
 * Endpoint pour récupérer les catégories de personnel
 */
export const RETRIEVE_STAFF_CATEGORIES_ENDPOINT_START = "/api/entity/contrat-client/"
export const RETRIEVE_STAFF_CATEGORIES_ENDPOINT_END = "/categorie-personnel"

/**
 * Endpoint pour créer un groupe de session
 */
export const CREATE_SESSION_GROUP_ENDPOINT = "/api/entity/groupe-session"

/**
 * Endpoint pour récupérer les groupes de session
 */
export const RETRIEVE_SESSION_GROUPS_ENDPOINT_START = "/api/entity/contrat-client/"
export const RETRIEVE_SESSION_GROUPS_ENDPOINT_END = "/groupe-session"

/**
 * Endpoint pour récupérer les commandes
 */
export const RETRIEVE_ORDERS_ENDPOINT_START = ENTITY_API + CONTRACT + "/"
export const RETRIEVE_ORDERS_ENDPOINT_END = ORDERS

export const RETRIEVE_ORDER_ENDPOINT = ENTITY_API + ORDERS
export const RETRIEVE_PURCHASE_ORDER_ENDPOINT = id => ENTITY_API + ORDERS + "/" + id + "/bon-commande"

/**
 * Endpoint pour récupérer les lignes de commande
 */
export const RETRIEVE_ORDER_LINES_ENDPOINT_START = ENTITY_API + ORDERS + "/"
export const RETRIEVE_ORDER_LINES_ENDPOINT_END = ORDER_LINES

/**
 * Endpoint pour récupérer les statuts de facturation
 */
export const RETRIEVE_BILLING_STATUSES_ENDPOINT = "/api/entity/ref-statut-facturation"

/**
 * Endpoint pour récupérer une demande de gestion.
 */
export const RETRIEVE_MANAGEMENT_REQUEST_ENDPOINT_START = ENTITY_API + MANAGEMENT_REQUEST + "/"

/**
 * Endpoint pour rechercher des demandes de gestion.
 */
export const RETRIEVE_MANAGEMENT_REQUESTS_SEARCH_ENDPOINT_END = "/recherche"

/**
 * Endpoint pour obtenir tous les interlocuteurs créateurs
 */
export const RETRIEVE_MANAGEMENT_CREATORS_INTERLOCUTORS_ENDPOINT = "/interlocuteurs-createurs"

/**
 * Endpoint pour obtenir tous les interlocuteurs en charge
 */
export const RETRIEVE_MANAGEMENT_IN_CHARGE_INTERLOCUTORS_ENDPOINT = "/interlocuteurs-en-charge"

/**
 * Endpoint pour créer une demande de gestion.
 */
export const CREATE_MANAGEMENT_REQUEST_ENDPOINT_START = ENTITY_API + MANAGEMENT_REQUEST

/**
 * Endpoint pour mettre à jour une demande de gestion.
 */
export const UPDATE_MANAGEMENT_REQUEST_ENDPOINT_START = ENTITY_API + MANAGEMENT_REQUEST + "/"

/**
 * Endpoint pour récupérer les suivis d'une demande de gestion.
 */
export const RETRIEVE_MANAGEMENT_REQUEST_FOLLOW_UPS_ENDPOINT_START = ENTITY_API + MANAGEMENT_REQUEST + "/"
export const RETRIEVE_MANAGEMENT_REQUEST_FOLLOW_UPS_ENDPOINT_END = "/suivi"

/**
 * Endpoint pour ajouter un suivi à une demande de gestion.
 */
export const ADD_MANAGEMENT_REQUEST_FOLLOW_UP_ENDPOINT_START = ENTITY_API + MANAGEMENT_REQUEST + "/"
export const ADD_MANAGEMENT_REQUEST_FOLLOW_UP_ENDPOINT_END = "/suivi"

/**
 * Endpoint pour récupérer les fichiers d'une demande de gestion.
 */
export const RETRIEVE_MANAGEMENT_REQUEST_FILES_ENDPOINT_START = ENTITY_API + MANAGEMENT_REQUEST + "/"
export const RETRIEVE_MANAGEMENT_REQUEST_FILES_ENDPOINT_END = "/fichiers"

/**
 * Endpoint pour téléverser les fichiers d'une demande de gestion.
 */
export const UPLOAD_MANAGEMENT_REQUEST_FILES_ENDPOINT_START = ENTITY_API + MANAGEMENT_REQUEST + "/"
export const UPLOAD_MANAGEMENT_REQUEST_FILES_ENDPOINT_END = "/fichier"

/**
 * Endpoints pour télécharger les factures d'une commande
 */
export const BILL_ENDPOINTS = {
    downloadBills: orderId => ENTITY_API + ORDERS + "/" + orderId + BILLS + "/telecharger",
}
/**
 * Endpoints contrats
 */
export const CONTRACT_ENDPOINTS = {
    retrieveBeneficiaryAreaParameter: contractId => ENTITY_API + CONTRACT + "/" + contractId + "/param-espace-compte",
    validateCodeEntreprise: codeEntreprise => ENTITY_API + CONTRACT + "/validation-code-entreprise/" + codeEntreprise,
    getChampMatricule: contractId => ENTITY_API + CONTRACT + "/champ-matricule/" + contractId,
    isInscriptionSelfCare: contractId => ENTITY_API + CONTRACT + "/is-inscription-self-care/" + contractId,
}

export const TUTORS_ENDPOINTS = {
    createBeneficiaryInterlocutor: (contractId, interlocutorId) =>
        ENTITY_API + CONTRACT + "/" + contractId + TUTORS + "/" + interlocutorId + "/interlocuteur-beneficiaires",
    createTutor: contractId => ENTITY_API + CONTRACT + "/" + contractId + TUTORS,
    deleteBeneficiaryInterlocutor: (contractId, interlocutorId, interlocutorBeneficiaryId) =>
        ENTITY_API +
        CONTRACT +
        "/" +
        contractId +
        TUTORS +
        "/" +
        interlocutorId +
        "/interlocuteur-beneficiaires" +
        "/" +
        interlocutorBeneficiaryId,
    deleteTutor: (contractId, interlocutorId) =>
        ENTITY_API + CONTRACT + "/" + contractId + TUTORS + "/" + interlocutorId,
    generateBeneficiaryBypassLoginToken: (contractId, beneficiaryId) =>
        ENTITY_API +
        CONTRACT +
        "/" +
        contractId +
        TUTORS +
        "/acces-compte/beneficiaires/" +
        beneficiaryId +
        "/generer-jeton",
    retrieveBeneficiariesForAccess: contractId =>
        ENTITY_API + CONTRACT + "/" + contractId + TUTORS + "/acces-compte/beneficiaires",
    retrieveInterlocutorBeneficiaries: (contractId, interlocutorId) =>
        ENTITY_API + CONTRACT + "/" + contractId + TUTORS + "/" + interlocutorId + "/interlocuteur-beneficiaires",
    retrieveTutors: contractId => ENTITY_API + CONTRACT + "/" + contractId + TUTORS,
    updateBeneficiaryInterlocutor: (contractId, interlocutorId, interlocutorBeneficiaryId) =>
        ENTITY_API +
        CONTRACT +
        "/" +
        contractId +
        TUTORS +
        "/" +
        interlocutorId +
        "/interlocuteur-beneficiaires" +
        "/" +
        interlocutorBeneficiaryId,
    updateTutor: (contractId, interlocutorId) =>
        ENTITY_API + CONTRACT + "/" + contractId + TUTORS + "/" + interlocutorId,
}

/**
 * Endpoints banques
 */
export const BANKS_ENDPOINTS = {
    retrieveById: id => ENTITY_API + BANKS + "/" + id,
    search: () => ENTITY_API + BANKS,
}

/**
 * Comptes bancaires
 */
export const BANK_ACCOUNT_ENDPOINTS = {
    retrieve: () => ENTITY_API + BANK_ACCOUNTS,
}

/**
 * Endpoints motifs de commande
 */
export const ORDER_REASONS_ENDPOINTS = {
    retrieveAll: ENTITY_API + ORDER_REASONS,
}

/**
 * Endpoints types de commande
 */
export const ORDER_TYPES_ENDPOINTS = {
    retrieveByContract: contractId => ENTITY_API + ORDER_TYPES + "/" + contractId,
}

/**
 * Endpoints types d'état de titre
 */
export const TITLE_STATE_TYPES_ENDPOINTS = ENTITY_API + TITLE_STATE_TYPES

/**
 * Endpoints types de commande
 */
export const INTERLOCUTEUR_CLIENT_ENDPOINTS = {
    updateInterlocuteurClientCguAcceptationDate: () => SERVICE_API + "/interlocuteur-client/accept-cgu",
}

/***************************************/
/*              ACTUATOR               */
/***************************************/

export const ACTUATOR_ENDPOINTS = {
    getAPIHealth: "/actuator/health",
}

export const PARAMETER_ENDPOINT = {
    getParameterServiceFromId: paramId => "/api/service/parametres/" + paramId,
    getParameterCesuFromId: paramId => "/api/entity/parametres/" + paramId,
}
